import './App.css';
import Console from './components/Console';

function App() {
  return (
    <div className="App">
      <Console />
    </div>
  ); 
  
}

export default App;